import BaseModel from "./base/baseModel";

export default class FarmacopeiaModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
}
